<template>
  <div class="client-one-service_tbody_sub_service">
    <input
      v-if="!hasServiceLevels"
      type="radio"
      name="client-one-service__sub"
      :id="'service-'+service_index"
      class="checkedRadio"
    >
    <label
      @click="$emit('click')"
      :for="'service-'+service_index"
      class="client-one-service__item"
      :class="!hasServiceLevels ? 'no-levels': ''"
    >
      <i class="material-icons">add</i>
      <h4 class="client-one-service__name">{{service_name}}</h4>
      <span v-if="!hasServiceLevels" class="client-one-service__price">{{service_price}}₽</span>
    </label>
    <input v-if="hasServiceLevels" type="radio" :id="'service-'+service_index" name="client-one-service__sub" class="checkedRadio">
    <div v-if="hasServiceLevels" class="client-one-service__sub-service">
      <div
        v-for="(level, index) in service.levels"
        class="client-one-service__sub-individual"
        :key="index"
      >
        <input
          type="radio"
          name="client-one-service__sub__individual"
          :id="'sub_standard-'+service_index+'-'+index"
          class="checkedRadio"
        >
        <label
          class="client-one-service__sub-service-item"
          :class="(level.options && level.options.length === 0) ? 'no-params' : ''"
          :for="'sub_standard-'+service_index+'-'+index"
          @click="setSubServiceLevel(level.id)"
        >
          <span class="client-one-service__price">{{level.name}}</span>
          <span class="client-one-service__price">{{level.is_fixed_price ? '' : 'от'}} {{level.price}}₽</span>
        </label>
      </div>
      <!-- <div class="client-one-service__sub-individual">
        <input type="radio" name="client-one-service__sub" :id="'sub_bussiness-'+service_index">
        <label
          class="client-one-service__sub-service-item"
          :class="cls"
          :for="'sub_bussiness-'+service_index"
        >
          <span class="client-one-service__price">Бизнес</span>
          <span class="client-one-service__price">{{service_price}}</span>
        </label>
      </div>
      <div class="client-one-service__sub-individual">
        <input type="radio" name="client-one-service__sub" :id="'sub_vip-'+service_index">
        <label
          class="client-one-service__sub-service-item"
          :class="cls"
          :for="'sub_vip-'+service_index"
        >
          <span class="client-one-service__price">Vip</span>
          <span class="client-one-service__price">{{service_price}}</span>
        </label>
      </div>-->
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  name: "OneService",
  props: {
    service_name: String,
    service_price: Number,
    service_dur: String,
    service_id: Number,
    service_index: Number,
    params_lenght: Number,
    service: Object
  },
  data() {
    return {
      show: false,
      checkedRadio: false
    };
  },
  methods: {
    ...mapMutations("client", ["setCustomerServiceLevel"]),
    setSubServiceLevel(level) {
      this.$emit("onSetSubServiceLevel", level);
      this.setCustomerServiceLevel(level);
    },
    uncheckedRadio() {
      let radioEl = document.querySelectorAll('input[class=checkedRadio]');
      radioEl && radioEl.length && radioEl.forEach(e => e.checked = false);
    }
  },
  computed: {
    cls() {
      return this.params_lenght === 0 ? "no-params" : "";
    },
    hasServiceLevels() {
      return this.service && this.service.levels && this.service.levels.length > 0;
    }
  }
};
</script>

